import { render, staticRenderFns } from "./ResidentialForSale.vue?vue&type=template&id=5def763b&scoped=true&"
import script from "./ResidentialForSale.vue?vue&type=script&lang=ts&"
export * from "./ResidentialForSale.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialForSale.vue?vue&type=style&index=0&id=5def763b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def763b",
  null
  
)

export default component.exports